import { FETCH_TEAMS, ADD_TEAM, EDIT_TEAM, DELETE_TEAM, DESTROY_TEAM } from '../actionTypes';

export const addTeam = team => ({
    type: ADD_TEAM,
    team
});

export const fetchTeams = teams => ({
    type: FETCH_TEAMS,
    teams
});

export const editTeam = teamView => ({
    type: EDIT_TEAM,
    teamView
});

export const delTeam = id => ({
    type: DELETE_TEAM,
    id
});

export const destroyTeam = key => ({
    type: DESTROY_TEAM,
    key
});